var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 40,
    height: 40,
    transform: "translate(222 163)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    transform: "translate(-222 -163)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ion-chatbox-outline",
    "data-name": "Icon ion-chatbox-outline",
    d: "M6.524,3.5H24.2A4.171,4.171,0,0,1,28.35,7.649V18.813A4.171,4.171,0,0,1,24.2,22.964H14.754L9.425,27.407a.9.9,0,0,1-1.469-.688V22.964H6.526a4.171,4.171,0,0,1-4.151-4.149V7.651A4.171,4.171,0,0,1,6.524,3.5ZM24.2,21.173a2.374,2.374,0,0,0,2.36-2.362V7.651A2.374,2.374,0,0,0,24.2,5.291H6.529A2.375,2.375,0,0,0,4.166,7.654V18.813a2.374,2.374,0,0,0,2.362,2.36H8.852a.9.9,0,0,1,.9.9v2.738l3.979-3.318a1.363,1.363,0,0,1,.872-.316Z",
    transform: "translate(226.625 167.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.23a4748fe95e5f9cc4896a4ce9dba553.svg";
export { ForwardRef as ReactComponent };